import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('core-app-bar'),_c('core-drawer'),_c('core-view-invoice-view'),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }